import type { CompanyRegistration, CompanyRegistrationType } from "@/graphql/codegen/graphql"
import { RESET, SET_DIALOG, SET_REGISTRATION, SET_TAB } from "@/screens/CompanySettings/Registration/constants"

interface State {
  openDialog: boolean
  selectedTab: CompanyRegistrationType | undefined
  selectedRegistration: CompanyRegistration | undefined // Replace `any` with the appropriate type
}

export const initialState: State = {
  openDialog: false,
  selectedTab: undefined,
  selectedRegistration: undefined,
}

type Action =
  | { type: typeof SET_DIALOG; payload: boolean }
  | { type: typeof SET_TAB; payload: CompanyRegistrationType | undefined }
  | { type: typeof SET_REGISTRATION; payload: CompanyRegistration | undefined } // Replace `any` with the appropriate type
  | { type: typeof RESET }

export const registrationDialogReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case SET_DIALOG:
      return { ...state, openDialog: true }
    case SET_TAB:
      return { ...state, selectedTab: action.payload }
    case SET_REGISTRATION:
      return { ...state, selectedRegistration: action.payload }
    case RESET:
      return initialState
    default:
      return state
  }
}
